import { forwardRef } from "react";
import React from "react";
function SvgDefaultNoImage({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={209}
      height={184}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#B582DA"
        d="m54.264 99.58 7.818-2.112 9.079-1.862 6.584-1.236s6.11-2.046 6.491-1.524c6.692 4.974 15.257 7.368 23.655 6.415a29.938 29.938 0 0 0 15.911-6.46s9.428 3.239 9.284 3.665c.379 4.177 2.777 8.125 6.315 10.392l4.654 4.27 3.429 4.958s4.651 18.737 5.035 18.796c13.028.74 26.128-7.118 31.577-18.946l3.394 4.188 9.986 14.926 5.583 9.795 3.338 10.061 1.383 8.405.056 7.24-2.251 9.004s-.384.131.038.602c-4.414 8.282-12.662 14.425-21.874 16.292-9.212 1.868-19.209-.58-26.57-6.35-.054 4.582-1.896 9.121-5.693 12.994-2.897 6.873-9.858 11.857-17.31 12.395l-18.491 3.093-21.49-.299-9.163-1.443-18.04-4.766s-12.218-6.329-11.895-6.114c-8.339 3.136-17.665 3.599-26.274 1.3-8.608-2.296-16.458-7.341-21.913-14.523-6.908-12.739-7.552-28.677-1.715-42.721 4.561-13.66 12.675-26.122 23.441-35.376 7.023-7.006 17.322-12.2 25.625-15.064l.003.005Z"
      />
      <path
        fill="#EFB595"
        d="M59.476 157.998c-5.153 6.326-7.813 14.619-7.3 22.754.512 8.136 4.192 16.032 10.098 21.666l6.74-3.919 6.606-6.169 4.87-5.059 7.377-10.552 1.447-2.938s41.342-4.755 41.857-5.083c2.905-1.241 3.672-5.719 1.349-7.853l-17.874-7.514-11.53-.315-8.14-2.754-35.5 7.733v.003ZM152.239 134.686c13.308.664 26.648-7.275 32.391-19.27 0 0-16.234-22.203-16.178-22.414.168-5.6-3.078-11.167-8.061-13.919a7.247 7.247 0 0 0-2.083-4.81c-1.263-1.271-3.014-2.041-4.723-2.23-.214-2.329-2.31-4.19-4.606-4.665-2.296-.474-4.697.216-6.753 1.338-3.407 1.859-5.805 5.088-7.548 8.553-2.518 5.008-1.314 7.821.315 11.852-2.903 5.775-1.223 13.412 4.018 17.206 5.156 3.735 8.839 9.443 10.104 15.671l3.119 12.688h.005ZM84.071 92.412c5.504 4.52 12.86 7.017 19.989 7.065 7.129.048 14.25-2.422 19.815-6.87l-4.609-2.582-3.717-2.267-.825-1.74-.665-1.93s.15-14.103.086-14.25c4.691-1.755 8.472-5.775 9.925-10.56l.475-5.322.499-7.829-.478-11.79-1.276-7.494-1.543-5.442s-3.781-8.38-3.947-8.338c-7.137-3.513-16.191-2.762-22.648 1.878-6.456 4.64-10.04 12.97-9.017 20.63-4.197.839-7.254 5.41-6.416 9.597.839 4.188 5.42 7.238 9.618 6.404l1.13 16.958-.447 7.156-.28 8.353-1.442 4.628-4.23 3.74.003.005Z"
      />
      <path
        fill="#080717"
        d="M137.478 71.354c-.494-.789-.988-1.577-1.417-2.083 1.959-2.539 5.035-4.188 8.24-4.422 0 0 1.134 2.386.987 2.464-2.865.703-5.511 2.267-7.807 4.04h-.003ZM154.203 100.836c.409.743.817 1.487 1.311 2.2 3.322-.215 6.334-2.847 6.988-6.103l-1.367-1.595-6.929 5.498h-.003ZM102.903 39.817c1.069 0 1.935-1.073 1.935-2.397 0-1.324-.866-2.398-1.935-2.398s-1.936 1.074-1.936 2.398.867 2.397 1.936 2.397ZM120.526 40.217c1.069 0 1.936-1.073 1.936-2.398 0-1.324-.867-2.397-1.936-2.397s-1.936 1.073-1.936 2.397c0 1.325.867 2.398 1.936 2.398ZM82.27 37.761l1.479-1.004 3.076-.314c.71-.043 1.42.16 2.024.535.71.44 1.631-.08 1.658-.913.032-1.053.07-2.11.11-3.173a3.658 3.658 0 0 1 1.1-2.478 144.38 144.38 0 0 1 2.042-1.952c.865-.813 1.252-2.025.97-3.175-.636-2.582.066-5.499 1.906-7.462 2.253-2.403 6.056-3.207 9.094-1.918 2.785 1.18 5.973 1.622 8.862.73 2.892-.893 5.402-3.26 5.808-6.14-8.382-3.168-18.304-1.9-25.615 3.274-7.308 5.173-11.788 14.1-12.515 23.99Z"
      />
      <path
        fill="#080717"
        d="M81.713 38.625c-1.682-6.241-2.72-12.653-2.932-18.777.417-3.61 3.431-6.764 6.174-6.841-.684-3.95 1.802-7.96 5.23-10.05C93.614.864 97.568.238 101.584.065c4.053-.176 7.418-.045 12.267.956 3.922.81 7.444 4.284 6.336 8.122 4.427 2.925 5.628 9.734 2.243 13.903-.812-3.428-2.743-6.585-5.511-8.623-7.415-.533-16.392-1.67-21.917 4.713-4.86 5.612-10.517 10.71-13.286 19.491l-.003-.003ZM98.356 66.33c2.971 6.202 8.496 11.14 15 13.41 0 0 1.146-9.664 1.204-9.776-6.464.636-9.919.98-16.204-3.634ZM163.012 104.502c2.205-3.194 6.194-5.072 10.069-4.737 0 0-4.911-6.45-4.943-6.425-.526 4.193-2.114 8.253-5.126 11.159v.003ZM157.804 190.538c0-5.687 1.138-12.395 4.916-16.473-2.355-6.026-4.71-12.051-6.98-17.835-.456 11.146-.23 22.899 2.064 34.306v.002ZM68.82 127.92l.347 28.232-2.782-.235 2.432-27.997h.003Z"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M115.462 13.707c6.836 4.505 7.904 12.051 8.83 19.723.929 7.672.406 15.435-.115 23.144-.384 5.666-4.301 10.943-9.62 12.965-5.322 2.022-11.765.68-15.829-3.298M88.138 35.657c-3.108-.207-6.264 1.535-7.74 4.27-1.477 2.736-1.197 6.322.689 8.797 1.885 2.474 5.273 3.705 8.183 3.05 1.426 11.327 1.627 23.778-.082 34.119a7.106 7.106 0 0 1-2.735 4.536c-3.532 2.64-9.414 4.172-15.404 5.147-9.412 1.534-19.572 4.065-27.953 8.607-20.934 11.34-40.709 36.849-42.06 67.033-.609 13.608 6.489 26.522 18.563 32.883 11.991 6.319 26.947 5.762 39.264.107 12.304-5.65 22.077-15.957 28.723-27.731"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M35.674 161.369a674.58 674.58 0 0 0 59.111-11.116c9.535 3.338 19.067 6.673 28.442 10.043 2.174.78 3.429 3.13 2.729 5.327-.483 1.519-1.543 2.827-3.009 3.264"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M102.16 152.768c4.077.215 8.152.431 12.371.753 5.434 2.172 10.867 4.343 16.392 6.756 2.144.938 3.287 3.351 2.531 5.56-.467 1.366-1.396 2.552-2.659 3.052M96.506 154.902c6.373 3.064 12.747 6.127 19.302 9.281 1.963.946 1.989 3.778.011 4.686l-.046.021M87.182 157.885c3.009 1.955 6.018 3.913 9.452 6.172l3.693 4.507M79.94 164.136l6.752 4.478M85.443 39.337a11.523 11.523 0 0 1 4.817 7.088M59.964 157.462c-5.738 6.169-7.842 14.459-7.503 22.867.339 8.409 3.255 15.826 9.47 21.516M68.572 127.746l-2.181 28.008"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M154.477 147.853c1.424 13.127 2.278 26.316 2.7 39.678.398 12.525-7.784 23.727-19.847 27.225-26.944 7.813-57.216 4.731-81.855-8.719M153.262 71.338c-1.025-2.63-3.914-4.406-6.729-4.135-7.083.68-12.317 7.85-13.454 14.86-.425 2.61.611 5.98 2.018 6.861"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M159.877 78.514c.136-2.578-1.768-4.981-4.168-5.945-2.4-.965-5.161-.672-7.578.245-2.416.916-4.566 2.413-6.683 3.894-2.216 1.55-4.163 5.102-3.306 7.739"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M155.423 108.872c5.57-2.07 10.31-6.641 11.901-12.352 1.592-5.712-.347-12.42-5.156-15.901-4.809-3.482-11.201-3.01-15.086 1.473"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M158.495 85.914a13.406 13.406 0 0 0-7.925 4.47 13.333 13.333 0 0 0-3.17 8.514c-.005 1.222.729 2.421 1.824 2.97 1.095.549 2.497.426 3.479-.309 3.074-2.299 6.147-4.598 9.22-6.894"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M143.002 98.01c1.898-2.376 3.5-5.38 4.934-8.63 1.228-2.782.932-5.273-1.081-7.553-2.014-2.28-5.303-2.142-7.081.36-3.648 5.128-4.962 6.321-5.896 9.93-.935 3.61-.646 6.511 1.039 9.838a11.982 11.982 0 0 0 3.914 4.46c4.155 2.823 7.359 6.825 8.996 11.566 3.303 9.564 4.635 19.532 6.643 29.87 2.707 13.94 7.53 29.966 19.369 37.848"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M147.403 98.45c-1.602-.458-2.662-1.9-2.333-3.436M153.945 100.633c.494.815.996 1.484 1.509 2.235 3.223-.186 6.211-2.538 7.137-5.626l-1.492-1.958M137.586 71.97c-.422-.679-1.247-2.16-1.672-2.911a21.066 21.066 0 0 1 7.706-4.734l1.706 2.592M97.217 32.762c.974-1.377 2.574-2.344 4.307-2.598 1.733-.253 3.564.211 4.934 1.247M123.626 31.5c-2.31-1.446-5.589-.684-7.396 1.35-1.808 2.036-2.257 5.033-1.627 7.678.631 2.645 2.217 4.976 4.064 6.974M101.584 47.246c.184 2.264 2.934 3.9 5.02 2.986M114.321 69.917c-.363 4.91-.59 9.19-.459 13.064a8.216 8.216 0 0 0 5.172 7.347c4.686 1.872 9.639 3.814 14.044 5.61M123.871 92.867c-5.767 4.267-12.95 6.593-20.13 6.521-7.18-.072-14.314-2.544-19.991-6.926M157.498 190.307c11.826 8.919 30.8 8.687 41.689-1.348 10.886-10.037 10.613-27.432 4.971-41.108-7.706-18.687-24.431-36.986-36.113-55.236"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M152.672 135.007c13.035.428 25.969-7.481 31.502-19.263"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.92}
        d="M133.867 56.416c1.645 3.056 3.624 6.51 5.268 9.566"
      />
      <path
        fill="#B582DA"
        d="M125.885 28.48c7.597 0 13.778 6.094 13.778 13.585 0 7.49-6.181 13.586-13.778 13.586-7.596 0-13.777-6.095-13.777-13.586 0-7.49 6.181-13.586 13.777-13.586Zm0-2.665c-9.083 0-16.447 7.275-16.447 16.25s7.364 16.25 16.447 16.25c9.084 0 16.448-7.275 16.448-16.25 0-8.974-7.364-16.25-16.448-16.25Z"
      />
      <g opacity={0.8}>
        <path
          fill="#fff"
          d="M125.677 54.408c6.93 0 12.549-5.516 12.549-12.32s-5.619-12.32-12.549-12.32c-6.931 0-12.55 5.516-12.55 12.32s5.619 12.32 12.55 12.32Z"
        />
        <path
          fill="#080717"
          d="M125.676 30.7c6.405 0 11.615 5.109 11.615 11.388s-5.21 11.388-11.615 11.388c-6.406 0-11.616-5.11-11.616-11.388 0-6.279 5.21-11.388 11.616-11.388Zm0-1.865c-7.447 0-13.485 5.932-13.485 13.253 0 7.32 6.038 13.252 13.485 13.252 7.446 0 13.484-5.932 13.484-13.252s-6.038-13.253-13.484-13.253Z"
        />
      </g>
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M133.68 56.36c7.998-4.35 10.99-14.264 6.684-22.143-4.306-7.88-14.28-10.74-22.278-6.39-7.997 4.35-10.99 14.264-6.684 22.143 4.306 7.88 14.28 10.74 22.278 6.39Z"
      />
      <path
        stroke="#080717"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.363}
        d="M125.881 55.34c7.332 0 13.276-5.933 13.276-13.252 0-7.32-5.944-13.253-13.276-13.253s-13.276 5.933-13.276 13.253c0 7.319 5.944 13.252 13.276 13.252Z"
      />
      <path
        fill="#080717"
        d="M142.192 199.132H53.614a.712.712 0 0 1-.708-.717v-13.903c0-.396.313-.716.708-.716h88.578c4.139 0 7.509 3.444 7.509 7.672 0 4.227-3.37 7.666-7.509 7.666v-.002Zm-87.876-1.439h87.871c3.362 0 6.099-2.794 6.099-6.23 0-3.437-2.735-6.234-6.099-6.234h-87.87v12.464Z"
      />
      <path
        fill="#080717"
        d="M88.531 199.132H53.614a.712.712 0 0 1-.708-.717v-13.903c0-.396.313-.716.708-.716H88.53c4.139 0 7.508 3.444 7.508 7.672 0 4.227-3.37 7.666-7.508 7.666v-.002Zm-34.215-1.439h34.21c3.361 0 6.1-2.794 6.1-6.23 0-3.437-2.733-6.234-6.1-6.234h-34.21v12.464Z"
      />
      <path
        fill="#8B1EA4"
        d="M51.76 183.874h93.654c4.051 0 7.332-3.354 7.332-7.491s-3.281-7.49-7.332-7.49H51.76v14.981Z"
      />
      <path
        fill="#080717"
        d="M145.413 184.597H51.759a.708.708 0 0 1-.702-.717v-14.979c0-.397.312-.716.702-.716h93.654c4.43 0 8.035 3.681 8.035 8.21 0 4.528-3.605 8.204-8.035 8.204v-.002Zm-92.95-1.441h92.953c3.653 0 6.625-3.037 6.625-6.769s-2.972-6.769-6.625-6.769H52.464v13.538Z"
      />
      <path
        fill="#FFDCF5"
        d="M51.76 183.874h37.62c4.05 0 7.331-3.354 7.331-7.491s-3.281-7.49-7.332-7.49H51.76v14.981Z"
      />
      <path
        fill="#080717"
        d="M89.384 184.597h-37.62a.708.708 0 0 1-.702-.717v-14.979c0-.397.313-.716.703-.716h37.62c4.429 0 8.033 3.681 8.033 8.21 0 4.528-3.604 8.204-8.034 8.204v-.002Zm-36.917-1.441h36.912c3.652 0 6.624-3.037 6.624-6.769s-2.972-6.769-6.624-6.769H52.467v13.538Z"
      />
      <path
        fill="#080717"
        d="M87.196 173.661H52.137a.712.712 0 0 1-.707-.717c0-.397.312-.716.707-.716h35.059c.39 0 .708.319.708.716a.712.712 0 0 1-.708.717ZM145.938 176.387h-43.424a.71.71 0 0 1-.707-.716c0-.397.312-.717.707-.717h43.424c.39 0 .703.32.703.717a.707.707 0 0 1-.703.716Z"
      />
      <path
        fill="#8B1EA4"
        d="M77.897 195.18v-17.163h11.38v17.163l-5.69-3.45-5.69 3.45Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDefaultNoImage);
export default ForwardRef;
